export function JeppesenEmblem({ margin }: { margin: string }) {
    const el = document.createElement('img');
    el.src = require(`./IconJeppesenCheck.png`);
    el.style.margin = margin;
    el.style.overflow = 'visible';
    el.setAttribute('width', '40px');
    el.setAttributeNS(null, 'viewBox', '0 0 508 508');

    return el;
}

export function LogoWithJeppesen({ margin }: { margin: string }) {
    const el = document.createElement('img');
    el.src = require(`./IconJeppesenText.png`);
    el.setAttribute('style', `margin: ${margin}`);
    el.setAttribute('width', '105px');
    el.setAttributeNS(null, 'viewBox', '0 0 292 94');
    el.setAttribute('id', 'logo-with-jeppesen');

    return el;
}
